import React from 'react';

import { INVALID_DATE } from 'app/models';

import { convertToDateTimeString } from 'utils/helpers/dateHelpers';

export const FormatDate = (params) => {
  const date = convertToDateTimeString(params.value);
  return <div data-testid="last-run">{date === INVALID_DATE ? '-' : date}</div>;
};
